import { InfoCircleOutlined, PlusCircleOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import {
    Button,
    Checkbox,
    Col,
    Empty,
    Form,
    Input,
    notification,
    Radio,
    Row,
    Select,
    Space,
    Table,
    Tag,
    Tooltip,
    Upload
} from "antd";
import { useEffect, useState } from "react";
import { 
    getAllMacScriptList, 
    getCommandPolicyCustomScript, 
    addCommandPolicyCustomScript,
    deleteCommandPolicyCustomScript 
} from "../../../axios/api.mac.management";

import i18n from "@src/locales";
import { useTranslation } from "react-i18next";

const { Column } = Table
const { Item } = Form;
interface propsModel {
    policyId: string,
    templateTab: any,
    updatePolicy: () => void,
}

export const MacCommandPolicyCustomScript = (props: propsModel) => {
    const { policyId, templateTab, updatePolicy } = props
    const [showTable, setShowTable] = useState<number>(0)
    const [dataForm] = Form.useForm()
    const [sourceType, setSourceType] = useState<string>();
    const [scriptId, setScriptId] = useState<string>();
    const [title, setTitle] = useState<string>();
    const [remark, setRemark] = useState<string>();
    const [content, setContent] = useState<string>();
    const [scriptName, setScriptName] = useState<string>();
    const [macScripts, setMacScripts] = useState<any[]>();
    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2)
    }

    useEffect(() => { getDataInfo(); getOptions() }, [])
    
    const getDataInfo = () => {        
        getCommandPolicyCustomScript(policyId).then(
            (res) => {
                if (res) {
                    setSourceType(res.sourceType);
                    console.log(res);
                    if(res.sourceType == "Select")
                    {
                        setScriptId(res.scriptId);
                    }
                    else
                    {
                        setTitle(res.title);
                        setRemark(res.remark);
                        setContent(res.content);
                    }
                    setShowTable(2)
                }
                else {
                    setSourceType("Select");
                    setShowTable(1)
                }
            },
            () => {
                notification.error({message: t("获取自定义脚本失败")})                    
            }
        )
    }

    const getOptions = () => {
        Promise.all(
            [getAllMacScriptList()]
        ).then(([res1]) => {
            setMacScripts(res1);
        });
    };

    const onSourceTypeSelect = (value: any, option: any) => {
        setSourceType(value);
    };

    const onScriptChange = (value: any, option: any) => {
        setScriptName(value ? option.children : "");
    };


    const addTemplateClick = () => {
        dataForm?.validateFields().then(
            (res) => {
                const {sourceType, scriptId, title, remark, content} = res;
                var obj = {
                    sourceType: sourceType,
                    scriptId: scriptId,
                    title: title,
                    remark: remark,
                    content: content
                };
                addCommandPolicyCustomScript(policyId, obj).then(
                    () => {
                        updatePolicy();
                        notification.success({ message: t("成功") });
                        getDataInfo();
                    }, 
                    () => {
                        notification.error({ message: t("保存失败") })
                    }
                )
            }
        )
    }

    const deleteTemplateClick = () => {
        deleteCommandPolicyCustomScript(policyId).then(
            () => {
                updatePolicy();
                notification.success({ message: t("成功") });
                dataForm.resetFields();
                getDataInfo();
            },
            () => {
                notification.error({ message: t("删除失败") })
            }
        )
    }

    return (
        <>
            <div>
                <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                    <Col className="templateTitle">{t("自定义脚本")}</Col>
                </Row>
                <Row><div className="dividerStyle"></div></Row>
                <Row style={{ margin: "16px 16px 16px 0px" }}>
                    {showTable == 1 && (
                        <div>
                            <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                                {t("添加自定义脚本，在设备上执行")}
                            </p>
                            <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                                <Button onClick={() => { addClick(); }} type="primary">
                                    <PlusOutlined /> {t("添加规则")}
                                </Button>
                            </div>
                        </div>
                    )}
                    {showTable == 2 && (
                        <>
                            <Form
                                style={{ width: "50%", marginTop: 36, marginLeft: 45 }}
                                layout="vertical"
                                form={dataForm}
                                labelCol={{ span: 24 }}
                                initialValues={{ sourceType: sourceType, scriptId: scriptId,title: title, remark:remark, content:content }}
                            >
                                <Item label={t("脚本来源")} name="sourceType"  rules={[{ required: true }]}>
                                    <Select onChange={onSourceTypeSelect}>
                                    <Select.Option value="Create">{t("新建脚本")}</Select.Option>
                                    <Select.Option value="Select">{t("脚本库")}</Select.Option>
                                    </Select>
                                </Item>
                                {(sourceType == "Select") && <Item label={t("选择脚本")} name="scriptId" rules={[{ required: true }]}>
                                    <Select
                                        showSearch
                                        allowClear
                                        // style={{ width: 200 }}
                                        placeholder={t("请选择脚本")}
                                        optionFilterProp="children"
                                        onChange={onScriptChange}
                                        filterOption={(input, option) =>
                                            option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        >
                                        {
                                            Array.isArray(macScripts) ?
                                            macScripts.map(script => <Select.Option key={script.id} value={script.id}>{script.title}</Select.Option>) : ""
                                        }
                                    </Select>
                                </Item>}
                                {(sourceType == "Create") && <>
                                    <Item label={t("脚本标题")} name="title"  rules={[{ required: true }]}>
                                        <Input></Input>
                                    </Item>
                                    <Item label={t("脚本备注")} name="remark">
                                        <Input></Input>
                                    </Item>
                                    <Item label={t("脚本内容")} name="content" rules={[{ required: true }]}>
                                        <Input.TextArea rows={4}></Input.TextArea>
                                    </Item>
                                </>
                                }
                            </Form>
                            <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "80%" }}>
                                <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); }}> {t("保存")} </Button>
                                <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick();  }}>{t("删除规则")}</Button>
                            </div>
                        </>
                    )}
                </Row>
            </div>
        </>
    )
};